import { Component, Input, OnInit } from '@angular/core';
import { Camera, CameraResultType } from '@capacitor/camera';
import { ModalController, Platform } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { LoaderService } from 'src/app/services/loader.service';
import { AuthenticationStore } from 'src/app/stores/authentication.store';
import { OrdersData, OrdersService, RatingPayload } from 'src/app/stores/orders.store';

@Component({
  selector: 'app-rating',
  templateUrl: './rating.page.html',
  styleUrls: ['./rating.page.scss'],
})
export class RatingPage implements OnInit {

  description: string = "";
  @Input() type: number;
  @Input() orderDetails: OrdersData;
  rating: number = 0;
  image: string
  imageName: String
  constructor(private modalController: ModalController,
    private loaderService: LoaderService,
    private ordersService: OrdersService,
    private authenticationStore: AuthenticationStore,
    private translate: TranslateService,
    public platform: Platform

  ) { }

  ngOnInit() {
  }

  back() {
    this.modalController.dismiss();
  }
  async rate() {
    if (this.rating == 0) {
      this.loaderService.presentToast(this.translate.instant("RATE_ORDER.SELECT_STAR"), "bottom", "danger");
    } else {
      var data: RatingPayload = {
        star_rating: this.rating,
        comments: this.description,
        img: this.imageName,
        order_id: this.orderDetails.id
      }

      try {
        this.loaderService.showLoading()
        await this.ordersService.rateOrder(this.type, data)
        this.loaderService.dismissLoading();
        this.modalController.dismiss(1);
      } catch (error) {
        this.loaderService.dismissLoading();
        this.loaderService.presentToast(error.error.data ? error.error.data : this.translate.instant("RATE_ORDER.SOMETHING_WRONG"), "bottom", "danger")
      }

    }
  }

  async imageAction() {
    const image = await Camera.getPhoto({
      quality: 50,
      allowEditing: true,
      resultType: CameraResultType.DataUrl
    });
    this.image = image.dataUrl;
    this.loaderService.showLoading();
    try {
      var imageUrl = await this.authenticationStore.imageUpload(image.dataUrl)
      this.loaderService.dismissLoading();
      this.imageName = imageUrl.data.name
    } catch (error) {
      this.loaderService.dismissLoading();
      this.loaderService.presentToast(error.error.data
        ? error.error.data
        : this.translate.instant('RATE_ORDER.SOMETHING_WRONG'), 'bottom', 'danger');
    }

  }
}
